var $4d2161787abab08b$exports = {};
$4d2161787abab08b$exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`
};


export {$4d2161787abab08b$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
